<template>
    <div class="container" style= "margin-top:10%">
        <div id="murder-1">
            A murder has taken place
        </div>
        <div id="murder-2">
            It's upto you now.
        </div>
        <button class="action-button" v-on:click="handleButtonClick " >
            Solve it
        </button>
    </div>
</template>

<script>
export default {
  name: 'Intro',
  components: {
    
  },
  methods:{
    handleButtonClick(){
      this.$router.push({name:'Start'}  );
    }
  }
}
</script>

<style>
#murder-1 {
    /* position: absolute;
    width: 816px;
    height: 200px;
    left: 312px;
    top: 250px; */

    font-family: Poppins;
    font-style: normal;
    font-weight: normal;
    font-size: 82px;
    line-height: 123px;
    text-align: center;

    color: #FF5C5C;
}
#murder-2 {
    /* position: absolute;
    width: 816px;
    height: 200px;
    left: 312px;
    top: 545px; */

    font-family: Poppins;
    font-style: normal;
    font-weight: normal;
    font-size: 48px;
    line-height: 72px;
    text-align: center;
    margin-bottom: 4%;
    color: #000000;
    }
#name-input:focus {
    box-shadow: 0px 0px 8px 0px #0097CD;
}
.container {
  display:flex;
  align-items:center;
  justify-content: center;
  padding:2%;
  flex-direction: column;
}

.image{
    width: 213px;
    height: 196px;
}
.image-container{
    background-color: #FF5C5C;
    width: 312px;
    height: 251px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 2%;
}
.header-text{
  font-size: 48px;
  width: 646px;
}
.action-button{
  background-color: #FF5C5C;
  font-size: 32px;
  color: white;
  font-family: 'Poppins';
  width: 312px;
  height: 63px;
  border:none;
  border-radius: 20px;
  outline: none;
  border: none;
  margin:0.5%;  
}
.action-button:hover{
  cursor:pointer;
  opacity: 0.6;
}
</style>